import { createSelector } from 'reselect';
import { performanceChartNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Season.
 */
export const seasonSelector = createSelector(
    performanceChartNavSelector,
    (state) => state.season
);
